import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { IrisModalAboutComponent } from '@iris/common/modules/about/iris-modal-about.component';
import { HelpUrlSettingsService } from '@iris/modules/administration/administration-list/appearance-page/help-url-settings/help-url-settings.service';

@Component({
  selector: 'iris-header-help',
  templateUrl: './header-help.component.html',
  styleUrls: ['./header-help.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderHelpComponent implements OnInit {
  private readonly helpUrlSettingsService = inject(HelpUrlSettingsService);
  readonly dialog = inject(MatDialog);

  helpCenterUrl$ = this.helpUrlSettingsService.helpUrl$;

  ngOnInit(): void {
    this.helpUrlSettingsService.getHelpUrl().subscribe();
  }

  openModalAbout(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    this.dialog.open(IrisModalAboutComponent, dialogConfig);
  }
}
